import { useEffect } from 'react'
import { Page_Padding } from '../../shared/constants'
import { Box,  Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import VideoSection from './VideoSection'
import useResponsive from '../../shared/utils/Responsive'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { getImageUrl } from '../../shared/utils/getImageUrl'


const Camps = ({ onLoadingChange }) => {
    const { data: Detail, isLoading: isDetailLoading } = usePageContentWithMeta("SKILL_TO_SCHOOL");
    const isSmallScreen = useResponsive("sm")

    useEffect(() => {
        onLoadingChange(isDetailLoading);
    }, [isDetailLoading, onLoadingChange]);

    if (isDetailLoading) return null;

    return (
        <Box className="body camp">
            <Box px={Page_Padding} >
                <Box
                    sx={{
                        position: "relative",
                        backgroundImage: `url(${getImageUrl(Detail?.content[0]?.data?.imageUrl)})`,
                        // backgroundImage: `url(${Constants.customImages.CampsHeroImg})`,

                        backgroundSize: "cover",
                        backgroundPosition: "bottom",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "40px",
                        overflow: "hidden",
                        minHeight: "50vh"
                    }}
                />
                <CustomDivider />
                <Heading Heading={Detail?.content[1]?.data?.subheading} SubHeading={Detail?.content[1]?.data?.heading} mb={2} />
                <Typography variant="body1" color='grey.400' dangerouslySetInnerHTML={{ __html: Detail?.content[1]?.data?.description }} />
                <CustomDivider />
                <Heading SubHeading={Detail?.content[2]?.data?.heading} mb={1} />
                <Typography variant="body1" color='grey.400' dangerouslySetInnerHTML={{ __html: Detail?.content[2]?.data?.description }} />

                <Box
                    component={"img"}
                    src={getImageUrl(Detail?.content[2]?.data?.imageUrl)}
                    // src={Constants.customImages.ImpCurriculum}
                    alt='important of curriculum'
                    sx={{
                        width: { xs: "100%", sm: "60%" },
                        display: "block",
                        margin: "auto"
                    }}
                />

                <Heading
                    Heading={Detail?.content[3]?.data?.subheading}
                    SubHeading={Detail?.content[3]?.data?.heading} mb={2}
                />
                <Box
                    sx={{
                        position: "relative",
                        backgroundImage: `url(${getImageUrl(Detail?.content[3]?.data?.imageUrl)})`,
                        // backgroundImage: `url(${Constants.customImages.CampWord1})`,
                        backgroundSize: "100% auto",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        overflow: "hidden",
                        minHeight: { xs: "250px", sm: "400px", md: "120vh" },
                        "& .highlight-c": { color: "#3C8686", },
                        "& .highlight-a": { color: "#D39719", },
                        "& .highlight-m": { color: "#E3544D", },
                        "& .highlight-p": { color: "#85205E", },
                        "& .highlight-s": { color: "#40907A", },
                    }}
                />

                <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
                
            </Box>

            <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
            <VideoSection size={1.03}>
                {[
                    // "GWmDPMfhZdY", "OglJfZwE5Qc", "6JIpZfiUqOg",
                   "LGab-8Rf1jQ"

                ].map((item, index) => (
                    <Box key={index} sx={{ minWidth: "100%" }}>
                        <iframe
                            src={`https://www.youtube.com/embed/${item}?enablejsapi=1&controls=1&modestbranding=1&rel=0&disablekb=1&fs=0`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={`Embedded YouTube ${index}`}
                            style={{
                                width: "100%",
                                height: "400px",
                            }}
                        />
                    </Box>
                ))}
            </VideoSection>
            <Box
                component={"img"}
                // src={Constants.customImages.OurApproach}
                src={getImageUrl(Detail?.content[5]?.data?.imageUrl)}
                alt='our approach'
                sx={{
                    width: { xs: "100%", sm: "40%" },
                    display: "block",
                    margin: "0 auto 0 auto"
                }}
            />
            <Box
                sx={{
                    bgcolor: "#FFF7ED",
                    py: "2rem"
                }}
            >

                <Box
                    component={"img"}
                    // src={Constants.customImages.LearningOutcome}
                    src={getImageUrl(Detail?.content[6]?.data?.imageUrl)}
                    alt='Learning Outcome Frame'
                    width={"60%"}
                    sx={{
                        width: { xs: "100%", sm: "60%" },
                        display: "block",
                        margin: "auto"
                    }}
                />
            </Box>



            <Box
                component={"img"}
                // src={Constants.customImages.ExpertiseExperience}
                src={getImageUrl(Detail?.content[7]?.data?.imageUrl)}
                alt='expertise experience frame'
                sx={{
                    width: { xs: "100%", sm: "60%" },
                    display: "block",
                    margin: "auto"
                }}
            />
        </Box>
    )
}

export default Camps
